import Vue from 'vue'
import ImagePreview from './index.vue'

const ImagePreviewCreator = Vue.extend(ImagePreview)

const noop = () => {}

const defaultOptions = {
  initIndex: 0,
  images: [],
  isLoopEnabled: false,
  onClose: noop
}

export default function brbImagePreview(options = defaultOptions) {
  const instance = new ImagePreviewCreator()
  const mergedOptions = { ...defaultOptions, ...options }

  instance.initWithOptions(mergedOptions)

  instance.$mount()
  document.body.appendChild(instance.$el)

  instance.$on('close', mergedOptions.onClose)

  return {
    $instance: instance,
    close: instance.close
  }
}
